"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__private__ = exports.fetchText = exports.fetchJson = void 0;

var Cookies = require("js-cookie");

var defaultInit = {
  mode: 'cors',
  credentials: "omit"
};

function fetch(url, init) {
  if (init === void 0) {
    init = defaultInit;
  }

  return __awaiter(this, void 0, void 0, function () {
    var sessionTicketFromCookie, response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          sessionTicketFromCookie = Cookies.get('sessionTicketApi');

          if (init === defaultInit && sessionTicketFromCookie) {
            init.headers = {
              SessionTicket: sessionTicketFromCookie
            };
          }

          return [4
          /*yield*/
          , window.fetch(url, init)];

        case 1:
          response = _a.sent();

          if (!response || !response.ok) {
            throw response;
          }

          return [4
          /*yield*/
          , response];

        case 2:
          return [2
          /*return*/
          , _a.sent()];
      }
    });
  });
}
/**
 * Will perform a fetch request and return an object from the type TResponse if the request is successful.
 * Expects the api to send back valid JSON.
 * Docs for fetch parameters: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters
 */


function fetchJson(url, init) {
  if (init === void 0) {
    init = defaultInit;
  }

  return __awaiter(this, void 0, void 0, function () {
    var _this = this;

    return __generator(this, function (_a) {
      return [2
      /*return*/
      , fetch(url, init).then(function (response) {
        return __awaiter(_this, void 0, void 0, function () {
          var errorResponse;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                if (!!response.ok) return [3
                /*break*/
                , 2];
                return [4
                /*yield*/
                , response.json()];

              case 1:
                errorResponse = _a.sent();
                throw errorResponse;

              case 2:
                return [2
                /*return*/
                , response];
            }
          });
        });
      }).then(function (res) {
        return res.text();
      }).then(function (text) {
        return text.length ? JSON.parse(text) : {};
      }).then(function (response) {
        return response;
      })];
    });
  });
}

exports.fetchJson = fetchJson;
/**
 * Docs for fetch parameters: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch#Parameters
 */

function fetchText(url, init) {
  if (init === void 0) {
    init = defaultInit;
  }

  return __awaiter(this, void 0, void 0, function () {
    var response, text;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , fetch(url, init)];

        case 1:
          response = _a.sent();
          return [4
          /*yield*/
          , response.text()];

        case 2:
          text = _a.sent();
          return [2
          /*return*/
          , text];
      }
    });
  });
}

exports.fetchText = fetchText; // tslint:disable-next-line

exports.__private__ = {
  fetch: fetch
};